
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getTitularesByIdPaciente = async (idPaciente) => {
  const query = `
    query MyQuery($idPaciente : String!) {
      gettitulares(paciente: $idPaciente ) {
        total
        status
        message
        titulares {
          paciente {
            persona {
              id
              identificacion
              primerApellido
              primerNombre
            }
          }
          persona {
            id
            identificacion
            primerApellido
            primerNombre
          }
        }
      }
    }
  `;

  const variables = {
    idPaciente
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200) return null;
    return response.data.data.gettitulares;

  } catch (error) {
    console.log(error);
    return error
  }
}

const getTitularesByIdCita = async (idCita) => {
  const query = `  
      query FindCitaDetailByIdCita($idCita:ID!) {
    findCitaDetailByIdCita(idCita: $idCita) {
        id
        fechaCreacion
        ultimoCambio
        token
        detailsSeguro
        detallesTitulares
        estado
        cita {
            id
            fechaCreacion
            ultimoCambio
            token
            urlsMspPaciente
            urlsMspTitular1
            urlsMspTitular2
            urlsMspTitular3
            urlSolImgDer
            urlSolLabDer
            estadoCita
            estado
            estadoSignosvital
            fechaCita
            estadoActual
            horaCita
            encuesta
            derivacion
            codderivacion
            fecderivacion
            segderivacion
            urlDerivacion
            urlCodigoDer
            isInterconsulta
            estadoRevision
            fechaIngreso
            url007Recibido
            usuarioCreadorUsername
            paciente {
                id
                fechaCreacion
                ultimoCambio
                token
                numHistoriaClinica
                tipoCobertura
                estado
                persona {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    tipoIdentificacion
                    identificacion
                    primerApellido
                    segundoApellido
                    primerNombre
                    segundoNombre
                    fechaNacimiento
                    telefono
                    estadoCivil
                    sexo
                    correo
                    esDiscapacitado
                    tipoEmpresa
                    urlIdentificacion
                    urlCarnet
                    urlCarnetIsspol
                    urlCarnetIssfa
                    estado
                }
            }
        }
    }
}
    `;


  const variables = {
    idCita
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200) return null;

    const titulares = response.data.data.findCitaDetailByIdCita.detallesTitulares
    const paciente = response.data.data.findCitaDetailByIdCita.cita.paciente.persona

    console.log("titulares", titulares)

    return {
      paciente:paciente,
      titulares: titulares}

  } catch (error) {
    console.log(error);
    return null
  }
}





export const titularService = {
  getTitularesByIdPaciente,
  getTitularesByIdCita
}